import { getMessages } from '../../../../../../../store/constants';

export const BOARD_BUTTON_OPEN_IN_DRIVE = getMessages().getText('board_details__link_open_in_drive');
